import {BaseGame} from "./BaseGame";
import $ from "/js/libs/jquery-3.3.1.min.js";
import "../../libs/limacharlie.helpers.js";
import {gsap, SplitText} from "/js/libs/gsap/all.js"
import {Simulator} from "../components/Simulator";
import {MystMQTT} from "../MystMQTT";
import FontFaceObserver from "../../libs/fontfaceobserver";

export class BaseGameMyst extends BaseGame {

  constructor(dataFile) {
    super(dataFile);

    // URL params
    const searchParams = new URLSearchParams(window.location.search);

    // Debug mode
    this.debugMode = searchParams.has('debug') ? searchParams.get('debug') : false;

    // Current quest ID
    this.currentQuestID = searchParams.has('queteId') ? searchParams.get('queteId') : false;

    // Simulator object
    this.simulator = null;

    // Current visitor data (coming from RFID)
    this.currentVisitorData = null;
  }

  preloadFont() {
    const fonts = [
      new FontFaceObserver("Sketchnote Dingbats", {weight: 400}),
      new FontFaceObserver("Sketchnote Text", {weight: 400, style: "normal"}), // normal
      new FontFaceObserver("Sketchnote Text", {weight: 400, style: "italic"}), // italic
      new FontFaceObserver("Sketchnote Text", {weight: 700, style: "normal"}), // bold
      new FontFaceObserver("Sketchnote Square", {weight: 400}),
    ];

    // Load each observer, then return promise
    let observers = [];
    for (let i = 0; i < fonts.length; i++) {
      observers.push(fonts[i].load());
    }

    return Promise.all(observers);
  }

  initSpokenTexts() {
    const split = new SplitText(".spoken-text-i18n > span", {
      type: "words,chars",
      // position: "absolute"
      charsClass: "letter"
    });
  }

  // To be overridden in child games
  initGame() {
    this.simulator = new Simulator(this.rfidScan.bind(this), this.data.base_station_rfid, this.debugMode);
    // this.initScreenSaver();
    this.goToScreen(1);

    // Prepare animated texts
    this.initSpokenTexts();

    // Animated border - check if boxes are too small, update classes
    $.each($(".container.animated-border"), (index, el) => {
      const $el = $(el);

      if ($el.outerHeight() <= 350) {
        $el.addClass("animated-border-small");
        $el.removeClass("animated-border");
      }
    });

    // if (inElectron()) {
    //   this.playAudioAmbiance()
    // } else {
    //   $(window).one('click', this.playAudioAmbiance());
    // }

    // Go to first screen
    // if (inElectron()) {
    // this.initScreenSaver();
    // this.goToScreen(1);
    // } else {
    // 	$("#first-click-interact").one(this.touchEvent, $.proxy(this.initScreenSaver, this));
    // 	this.goToScreen("first-click-interact");
    // }

    // Set initial Still There properties
    // gsap.set($("#still-there"), {autoAlpha: 0});

    // Remove arduino simulator if requested
    // if (typeof this.settings.rfid_simulator != "undefined" && this.settings.rfid_simulator === false) {
    //   $(".simulator").remove();
    // }
  };

  // To be overridden in child games
  initScreen(screenId) {

    // Super constructor
    if (BaseGame.prototype.initScreen.call(this, screenId) === false) {
      return false;
    }

    if (this.requestedLanguage !== false) {
      this.i18n.set(this.requestedLanguage);
      this.requestedLanguage = false;
    }
  }

  initMQTT() {
    return new Promise((resolve, reject) => {
      this.mqtt = new MystMQTT(this.data.base_station_rfid);
      this.mqtt.onConnected = () => $("#mqtt-status").addClass("connected")
      this.mqtt.onDisconnected = () => $("#mqtt-status").removeClass("connected")

      // Handle message through rfidScan() function
      this.mqtt.onMessage = (message) => this.rfidScan(message);

      this.mqtt.connect({
        url: this.settings.mqtt.url,
        username: this.settings.mqtt.username,
        password: this.settings.mqtt.password,
        topic: this.data.mqtt_topic,
        stationFilter: this.data.base_station_rfid || false,
      });

      // This is a fake Promise that always resolve
      resolve();
    });
  }

  rfidScan(scanData) {
    if (scanData != null) {
      // First let's see if we have a visitor already active on screen
      if (this.currentVisitorData) {
        if (this.currentVisitorData.visit_id != scanData.visit_id) {
          console.log("Visitor already active and ANOTHER VISITOR SCANNED")
          scanData.userSwitch = true;
        } else {
          console.log("Same visitor scanned, continue as normal");
        }
      } else {
        console.log("New visitor, continue as normal")
      }

      this.currentVisitorData = scanData;
      this.requestedLanguage = (this.currentVisitorData.lang === "en") ? "en" : "fr";
      if (this.i18n.lang !== this.requestedLanguage) this.i18n.set(this.requestedLanguage);
      this.dispatchEvent("rfidScan", scanData)
    }
  }

  /**
   * Used in Map and Remise
   *
   * @param queteId
   * @returns {string}
   */
  static getStationRFID(queteId) {
    return "RFID-1" + ((queteId < 10) ? "0" : "") + queteId.toString();
  }

  /**
   * Used in Map and Remise
   *
   * @param rfid
   * @param scanData
   * @returns {*|null}
   */
  static findStationScanData(rfid, scanData) {
    if (scanData.progress) {
      for (let i = 0; i < scanData.progress.length; i++) {
        if (scanData.progress[i].station == rfid) {
          return scanData.progress[i].state;
        }
      }
    }
    return null;
  }

  dispatchEvent(eventName, scanData) {
    const event = $.Event(eventName);
    event.scanData = scanData;
    this.onMessage(event);
  }

  // To be overridden in child games
  onMessage(e) {
    const type = e.type;
    const scanData = e.scanData;
  }

  reset(screenId, resetCallback) {
    this.started = false;

    if (typeof screenId == "undefined") {
      screenId = 1;
    }

    // Return to idle screen
    this.goToScreen(screenId, () => {
      resetCallback();

      $(this).trigger("resetComplete");
    }, true);
  }

}
